<template>
  <section class="tmf">
    <a
      :href="`https://tokyo42195.org/${langPath}`"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img src="../../../assets/images/logo-tmf.svg" alt="東京マラソン財団" />
    </a>
    <a
      :href="`https://www.marathon.tokyo/${langPath}`"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/tmf/tokyomarathon.svg"
        alt="東京マラソン"
      />
    </a>
    <a
      :href="`https://legacyhalf.tokyo/${langPath}`"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/tmf/tokyolegacyhalfmarathon.svg"
        alt="Tokyo Legacy Half Marathon"
      />
    </a>
    <a
      href="https://onetokyo.org/"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img src="../../../assets/images/tmf/onetokyo.svg" alt="ONE TOKYO" />
    </a>
    <a
      href="https://www.voluntainer.jp/"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/tmf/voluntainer.svg"
        alt="東京マラソン財団オフィシャルボランティアクラブ"
      />
    </a>
    <a
      :href="`https://www.marathon.tokyo/${langPath}charity/`"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/tmf/run-with-heart.svg"
        alt="Run with Heart"
      />
    </a>
    <a
      :href="`https://www.sportslegacy.jp/${langPath}`"
      class="tmf__link"
      target="_blank"
      rel="noopener"
    >
      <img
        src="../../../assets/images/tmf/sports-legacy.svg"
        alt="東京マラソン財団スポーツレガシー事業"
      />
    </a>
  </section>
</template>

<script>
export default {
  props: {
    langPath: {
      type: String,
    },
  },
  name: "TokyoMarathonFoundation",
};
</script>

<style scoped>
.tmf {
  padding: 60px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &__link {
    margin: 32px 0 0 0;
    &:hover {
      opacity: 0.4;
      transition-duration: 0.3s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/top/TokyoMarathonFoundation.vue